const cards = [
  {
    title: '某顶流深夜密会神秘女子，酒店共度8小时',
    tag: '恋情实锤',
    time: '2小时前',
    views: '128万',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20editorial%20image%2C%20warm%20crimson%20tone%2C%20abstract%20silhouette%20scene%20at%20night%2C%20luxury%20hotel%20ambience%2C%20cinematic%20mood%2C%20mysterious%20atmosphere%2C%20professional%20editorial%20photography%20style%2C%20no%20text%2C%20no%20visible%20faces&width=800&height=500&seq=card-01&orientation=landscape',
  },
  {
    title: '知名网红直播带货翻车，品牌方集体解约索赔',
    tag: '网红翻车',
    time: '5小时前',
    views: '96万',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20live%20streaming%20studio%20scene%20with%20warm%20lighting%2C%20products%20on%20display%2C%20chaotic%20atmosphere%2C%20red%20alert%20vibe%2C%20editorial%20news%20photography%2C%20cinematic%20composition%2C%20no%20text%2C%20no%20visible%20faces&width=800&height=500&seq=card-02&orientation=landscape',
  },
  {
    title: '热门综艺录制现场冲突，选手当场摔麦离场',
    tag: '综艺内幕',
    time: '8小时前',
    views: '85万',
    img: 'https://readdy.ai/api/search-image?query=TV%20studio%20stage%20with%20dramatic%20spotlight%2C%20empty%20microphone%20on%20floor%2C%20warm%20amber%20lighting%2C%20tense%20atmosphere%2C%20editorial%20photography%20style%2C%20cinematic%20mood%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=card-03&orientation=landscape',
  },
  {
    title: '昔日金童玉女被曝已分居半年，财产分割中',
    tag: '豪门恩怨',
    time: '12小时前',
    views: '73万',
    img: 'https://readdy.ai/api/search-image?query=Luxury%20mansion%20interior%20with%20split%20composition%2C%20warm%20golden%20light%2C%20elegant%20but%20sad%20mood%2C%20editorial%20photography%2C%20cinematic%20atmosphere%2C%20no%20text%2C%20no%20people%2C%20professional%20quality&width=800&height=500&seq=card-04&orientation=landscape',
  },
  {
    title: '多位艺人被约谈，娱乐圈税务整顿再升级',
    tag: '税务风波',
    time: '1天前',
    views: '67万',
    img: 'https://readdy.ai/api/search-image?query=Modern%20office%20building%20with%20dramatic%20sky%2C%20warm%20crimson%20sunset%20tones%2C%20serious%20mood%2C%20editorial%20news%20photography%20style%2C%20cinematic%20composition%2C%20no%20text%2C%20no%20people%2C%20professional%20quality&width=800&height=500&seq=card-05&orientation=landscape',
  },
  {
    title: '制片人朋友圈发文暗指某流量明星耍大牌',
    tag: '片场秘闻',
    time: '1天前',
    views: '58万',
    img: 'https://readdy.ai/api/search-image?query=Film%20set%20with%20director%20chair%20empty%2C%20warm%20studio%20lighting%2C%20dramatic%20shadow%2C%20editorial%20photography%20style%2C%20cinematic%20mood%2C%20professional%20quality%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=card-06&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            黑料精选
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto">
            每日精选最新51吃瓜黑料视频，实锤爆料一网打尽
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card, i) => (
            <a
              key={i}
              href="#media"
              className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/50 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-bold">
                    {card.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3 flex items-center gap-1 px-2 py-1 rounded-lg bg-black/60 text-background-50 text-xs">
                  <i className="ri-play-circle-fill"></i>
                  <span>视频</span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
                  {card.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {card.time}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {card.views} 次观看
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}